export default __webpack_public_path__ + "static/og-467f348f2357d3bdff1060aed721bc72.jpg";